<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="舰船型号" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择舰船型号">
                    <el-option v-for="item in typeOptions" :key="item.type" :label="item.type" :value="item.type">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="器材名称" prop="mname">
                <el-input v-model="ruleForm.mname" placeholder="请输入器材名称"></el-input>
            </el-form-item>
            <el-form-item label="器材型号" prop="mqmodel">
                <el-input v-model="ruleForm.mqmodel" placeholder="请输入器材型号"></el-input>
            </el-form-item>
            <el-form-item label="装备名称" prop="mzname">
                <el-input v-model="ruleForm.mzname" placeholder="请输入装备名称"></el-input>
            </el-form-item>
            <el-form-item label="装备型号" prop="mzmodel">
                <el-input v-model="ruleForm.mzmodel" placeholder="请输入装备型号"></el-input>
            </el-form-item>

            <div class="form-bottom">
                <el-button class="base-button"  size="mini" type="primary" @click="submitForm('ruleForm')">创建</el-button>
                <el-button class="base-button"  size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { createWxqc } from "@/api/equipmentDic/index.js"
import { getCommonAjax } from "@/api/common";
export default {
    props: ["subData"],
    data() {
        return {
            typeOptions: [],
            pidname:"",
            ruleForm: {
                mname: "",
                mqmodel: "",
                mzname: "",
                mzmodel: "",
                type: ""
            },
            rules: {
                mname: [
                    { required: true, message: "请输入器材名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                mzname: [
                    { required: true, message: "请输入装备名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                mqmodel: [
                    { required: true, message: "请输入器材型号", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                mzmodel: [
                    { required: true, message: "请输入装备型号", trigger: "blur" },
                    {
                        min: 2,
                        max: 50,
                        message: "长度在 2 到 50 个字符",
                        trigger: "blur",
                    },
                ],
                type: [
                    { required: true, message: "请选择舰船型号", trigger: "change" },
                ]
            },
        };
    },
    methods: {
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    createWxqc(this.ruleForm).then(() => {
                        this.$message({
                            message: "添加成功",
                            type: "success",
                        });
                        this.$bus.$emit("maintenance-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getShipType() {
            getCommonAjax("/wx/queryTypeList", {}).then(res => {
                this.typeOptions = res.result;
            }).catch(err => {
                console.error(err);
            });
        },
    },
    created() {
        this.getShipType();
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>